/**
 * Shared relative time formatter — Sprint 17g-4
 * Replaces duplicate formatTimeAgo (Home.tsx) and formatRelativeTime (Settings.tsx).
 */

export function formatTimeAgo(date: Date | null): string {
  if (!date) return 'Not yet refreshed';
  const ms = Date.now() - date.getTime();
  const minutes = Math.floor(ms / 60000);
  if (minutes < 1) return 'Updated just now';
  if (minutes < 60) return `Updated ${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Updated ${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `Updated ${days}d ago`;
}
